import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-100 pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo and Trust Section - Top on Mobile, Left on Desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Logo Section - Mobile only */}
          <div className="lg:col-span-1 text-center lg:text-left">
            <div className="block">
              <div className="mb-3 inline-flex flex-col items-center lg:items-start">
                <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-pink-500">
                  Style House
                </span>
                <h3 className="mt-1 flex items-end justify-center gap-2 lg:justify-start leading-none">
                  <span
                    className="text-[2.3rem] text-gray-700"
                    style={{
                      fontFamily:
                        '"Segoe Script", "Brush Script MT", "Lucida Handwriting", cursive',
                    }}
                  >
                    Ferrea
                  </span>
                  <span className="pb-1 text-[1.02rem] font-medium uppercase tracking-[0.2em] text-[#777b39]">
                    Fashion
                  </span>
                </h3>
              </div>
              <p className="text-sm text-gray-600">
                Curated style, seamless shopping, delivered to your doorstep.
              </p>
              <span className="mt-3 inline-block h-[2px] w-16 rounded-full bg-gradient-to-r from-pink-600 to-gray-300" />
            </div>

            {/* Trustpilot visible on desktop only */}
          </div>

          {/* Links Section on Desktop (Right Side) */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-8">
              {/* Company Links */}
              <div>
                <h3 className="font-bold text-gray-800 mb-4">Company</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/dashboard#customer-reviews"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Reviews
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy-policy"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Privacy policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/cookie-policy"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Cookie policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-and-conditions"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Terms & conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href="/faq"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>

              {/* Help & Support */}
              <div>
                <h3 className="font-bold text-gray-800 mb-4">Help & Support</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="#"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Sitemap
                    </a>
                  </li>
                  <li>
                    <a
                      href="/recent-orders"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Order Tracking
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-and-conditions#shipping-delivery-returns"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Returns & Refunds
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Shipping Information
                    </a>
                  </li>
                </ul>
              </div>

              {/* Customers */}
              <div>
                <h3 className="font-bold text-gray-800 mb-4">Customers</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/login"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Log in
                    </a>
                  </li>
                  <li>
                    <a
                      href="/register"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Register
                    </a>
                  </li>
                  <li>
                    <a
                      href="/wishlist"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      My Wishlist
                    </a>
                  </li>
                  <li>
                    <a
                      href="/recent-orders"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      My Orders
                    </a>
                  </li>
                </ul>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="font-bold text-gray-800 mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/products"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      All Products
                    </a>
                  </li>
                  <li>
                    <a
                      href="/categories"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Categories
                    </a>
                  </li>
                  <li>
                    <a
                      href="/blogs"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Fashion Blog
                    </a>
                  </li>
                  <li>
                    <a
                      href="/cart"
                      className="text-gray-600 hover:text-cyan-500 transition-colors text-sm"
                    >
                      Shopping Cart
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section - 3x2 grid on mobile, 6 columns on desktop */}
        <div className="border-t border-gray-300 pt-8 pb-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6">
            {/* Shipping */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-5 h-5 lg:w-7 lg:h-7 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  Shipping to
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  11+ Cities
                </p>
              </div>
            </div>

            {/* Secure Checkout */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-5 h-5 lg:w-7 lg:h-7 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  100% Secure
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  Checkout
                </p>
              </div>
            </div>

            {/* Support */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-5 h-5 lg:w-7 lg:h-7 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  Outstanding
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  Pan India Support
                </p>
              </div>
            </div>

            {/* Reviews */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-6 h-6 lg:w-8 lg:h-8 text-gray-700"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  Over 1000+
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  Reviews
                </p>
              </div>
            </div>

            {/* Returns */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-5 h-5 lg:w-7 lg:h-7 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  Easy 7-Day
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  Returns
                </p>
              </div>
            </div>

            {/* 24/7 Support */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="p-2 lg:p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-5 h-5 lg:w-7 lg:h-7 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[10px] lg:text-xs text-gray-500 uppercase">
                  24/7 Customer
                </p>
                <p className="font-bold text-xs lg:text-base text-gray-800">
                  Support
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-300 pt-6">
          {/* Country and Copyright */}
          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4 mb-4 md:mb-0">
              <button className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm hover:shadow-md transition-all">
                <span className="text-2xl">🇮🇳</span>
                <span className="text-sm font-medium text-gray-700">India</span>
                <svg
                  className="w-4 h-4 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c-1.657 0-3-4.03-3-9s1.343-9 3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 009-9"
                  />
                </svg>
              </button>
              <p className="text-sm text-gray-600">
                Copyright © {new Date().getFullYear()} | All Rights Reserved
              </p>
            </div>

            {/* Payment Methods - Reduced Size */}
            <div className="flex items-center space-x-3 flex-wrap justify-center">
              {/* Visa */}
              <button
                className="hover:opacity-70 transition-opacity cursor-pointer"
                title="Visa"
              >
                <svg className="w-10 h-6" viewBox="0 0 48 32" fill="none">
                  <rect width="48" height="32" rx="2" fill="#1434CB" />
                  <text
                    x="24"
                    y="22"
                    textAnchor="middle"
                    fill="white"
                    fontSize="9"
                    fontWeight="bold"
                  >
                    VISA
                  </text>
                </svg>
              </button>

              {/* Mastercard */}
              <button
                className="hover:opacity-70 transition-opacity cursor-pointer"
                title="Mastercard"
              >
                <svg className="w-10 h-6" viewBox="0 0 48 32" fill="none">
                  <circle cx="18" cy="16" r="10" fill="#EB001B" />
                  <circle cx="30" cy="16" r="10" fill="#F79E1B" />
                </svg>
              </button>

              {/* PhonePe */}
              <button
                className="hover:opacity-70 transition-opacity cursor-pointer"
                title="PhonePe"
              >
                <span className="text-base font-bold text-purple-700">
                  PhonePe
                </span>
              </button>

              {/* Paytm */}
              <button
                className="hover:opacity-70 transition-opacity cursor-pointer"
                title="Paytm"
              >
                <span className="text-base font-bold">
                  <span className="text-cyan-600">Pay</span>
                  <span className="text-blue-700">tm</span>
                </span>
              </button>

              {/* Google Pay */}
              <button
                className="hover:opacity-70 transition-opacity cursor-pointer"
                title="Google Pay"
              >
                <span className="text-sm font-bold flex items-center gap-1.5">
                  <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <defs>
                      <linearGradient
                        id="google-g-gradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#4285F4" />
                        <stop offset="25%" stopColor="#EA4335" />
                        <stop offset="50%" stopColor="#FBBC04" />
                        <stop offset="75%" stopColor="#34A853" />
                      </linearGradient>
                    </defs>
                    <text
                      x="12"
                      y="18"
                      textAnchor="middle"
                      fontSize="20"
                      fontWeight="bold"
                      fill="url(#google-g-gradient)"
                    >
                      G
                    </text>
                  </svg>
                  <span className="text-sm font-semibold text-gray-700">
                    Pay
                  </span>
                </span>
              </button>
            </div>
          </div>

          {/* Social Media Links & Developed By - Colorful icons with reduced gap */}
          <div className="border-t border-gray-300 pt-6">
            <div className="flex flex-col md:flex-row justify-center md:justify-between items-center space-y-4 md:space-y-0">
              {/* Social Media Icons - Colorful */}
              <div className="flex space-x-3">
                <a href="#" className="hover:opacity-80 transition-opacity">
                  <svg className="w-6 h-6" fill="#1877F2" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a href="#" className="hover:opacity-80 transition-opacity">
                  <svg
                    className="w-6 h-6"
                    fill="url(#instagram-gradient)"
                    viewBox="0 0 24 24"
                  >
                    <defs>
                      <linearGradient
                        id="instagram-gradient"
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                      >
                        <stop offset="0%" stopColor="#FED373" />
                        <stop offset="50%" stopColor="#F15245" />
                        <stop offset="100%" stopColor="#D92E7F" />
                      </linearGradient>
                    </defs>
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a href="#" className="hover:opacity-80 transition-opacity">
                  <svg className="w-6 h-6" fill="#1DA1F2" viewBox="0 0 24 24">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  </svg>
                </a>
                <a href="#" className="hover:opacity-80 transition-opacity">
                  <svg className="w-6 h-6" fill="#0A66C2" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
              </div>

              {/* Developed By Section */}
              <p className="text-sm text-gray-600">
                Developed by{" "}
                <a
                  href="https://eltovix.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-cyan-500 hover:text-cyan-600 transition-colors"
                >
                  Eltovix
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
